module.exports = __webpack_public_path__ + "img/registerBlue.588c9f4b.jpg";